/* src/app/components/login/login.component.css */
ul.row.tabs {
  margin: 0 -24px;
  width: calc(100% + 48px);
}
section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
form {
  width: 100%;
}
@media (min-width: 993px) {
  .container {
    width: 40%;
  }
}
button {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  background-color: #fff;
  color: rgba(0, 0, 0, .87);
  text-transform: initial;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.d-block {
  display: block !important;
}
.btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.btn:focus {
  background-color: initial;
}
.tabs .tab a {
  color: rgba(0, 0, 0, 0.7);
}
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: initial;
}
:host ::ng-deep .tabs .indicator {
  background:
    linear-gradient(
      157deg,
      #fb542b,
      #d12da7);
}
h6 {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #9E9E9E;
  line-height: 0.1em;
  margin: 25px 0;
}
h6 span {
  padding: 0 30px;
  background-color: #fafafa;
}
.activetab {
  height: 3px;
  margin-top: -3px;
}
/*# sourceMappingURL=login.component.css.map */
